module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item__schedule"
  }, [_c('p', {
    staticClass: "item__date"
  }, [_c('span', {
    staticClass: "item__day"
  }, [_vm._v(_vm._s(_vm.item.day))]), _c('span', {
    staticClass: "item__month"
  }, [_vm._v(_vm._s(_vm.item.month))])]), _c('p', {
    staticClass: "item__time"
  }, [_vm._v(_vm._s(_vm.item.time))])]), _c('div', {
    staticClass: "item__info"
  }, [_c('p', {
    staticClass: "item__number"
  }, [_c('span', {
    staticClass: "item__index"
  }, [_vm._v("Встреча №" + _vm._s(_vm.index))]), _c('span', {
    staticClass: "item__status",
    class: _vm.statusClass
  }, [_vm._v(_vm._s(_vm.meetingStatus))])])]), _c('Button', {
    attrs: {
      "bordered": true
    },
    on: {
      "click": _vm.openPopup
    }
  }, [_vm._v("Открыть")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-faa0c9be","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/programcard/components/main/components/list/components/item/MentoringListItem.vue
// module id = 5ab9ab3c0098ea45afac
// module chunks = 89